import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const AdminHeader: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname.includes('/admin');

  // Detect orientation
  function getOrientation() {
    if (typeof window === 'undefined') return 'horizontal';
    return window.innerHeight > window.innerWidth ? 'vertical' : 'horizontal';
  }
  const [orientation, setOrientation] = useState(getOrientation());
  useEffect(() => {
    const handleResize = () => setOrientation(getOrientation());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      {isAdminPage && (
        <nav className="bg-white shadow">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div
              className={`flex justify-between h-16 ${orientation === 'vertical' ? 'flex-col h-auto' : ''}`}
            >
              <div className={`flex ${orientation === 'vertical' ? 'flex-col items-start' : ''}`}>
                <div className="flex-shrink-0 flex items-center">
                  <Link to="/admin" className="text-xl font-bold text-gray-800">
                    ViooVIP Admin
                  </Link>
                </div>
                <div className={`ml-6 flex space-x-8 ${orientation === 'vertical' ? 'flex-col space-x-0 space-y-2 mt-2' : ''}`}>
                  <Link
                    to="/admin"
                    className="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/admin/stores"
                    className="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Stores
                  </Link>
                  <Link
                    to="/admin/links"
                    className="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Links
                  </Link>
                  <Link
                    to="/admin/appearance"
                    className="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Appearance
                  </Link>
                </div>
              </div>
              <div className={`flex items-center ${orientation === 'vertical' ? 'mt-2 self-start' : ''}`}>
                <Link
                  to="/logout"
                  className="text-gray-500 hover:text-gray-700"
                >
                  Logout
                </Link>
              </div>
            </div>
          </div>
        </nav>
      )}
      <main>{children}</main>
    </div>
  );
};

export default AdminHeader;